import React from 'react';

import styles from './styles.module.scss';

export const Columns: React.FC = ({ children }) => {
  return <div className={styles.wrapper}>{children}</div>;
};

export const Column: React.FC = ({ children }) => {
  return <div className={styles.column}>{React.Children.map(children, (child) => child)}</div>;
};
